export default __webpack_public_path__ + "static/media/project-wizard-tracks_dark.65e55da3.png";